import {
    Component,
    OnInit,
    OnDestroy,
    HostBinding,
    HostListener
} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { Subject, Observable, BehaviorSubject } from 'rxjs';
import { tap, map, takeUntil } from 'rxjs/operators';

import { AuthService, ApiService, LoginService } from '../../core/upgraded-providers';
import { LocalStorageService, SocketService as SocketServiceLegacy } from '../../core/upgraded-providers';
import { AlertService, ConfirmService } from '../../ui.module';

import { StoreService, IResourcesPrice } from '../../shared-services.module/store.service';

import { VersionService } from '../../version.service';
import { SessionService } from '../../session.service';
import { FeaturesService } from '../../features.service';

import { ToastrService } from '../../toastr.module/toastr.service';
import { ToastSuccessComponent } from '../../toastr.module/toast-success.component';

import {
    ShowDlgStoreCpuUnlockService, ACTIVATE_UNLOCK
} from '../../shared-dialogs.module/show-dlg-store-cpu-unlock.service';
import {
    ShowDlgStoreAccessKeyService, TRANSFER_KEYS
} from '../../shared-dialogs.module/show-dlg-store-access-key.service';
import {
    ShowDlgCouponService
} from '../../shared-dialogs.module/show-dlg-coupon.component';

import SocketService, { socketServiceFabric } from '../../shared-services.module/socket.service';
import { SeasonsService } from '../seasons.service';
import { getSeasonAccessCost } from '../dice';

const IS_NW = 'isNw';
const IS_NOT_NW = 'isNotNw';
const IS_PTR = 'isPtr';
const IS_NOT_PTR = 'isNotPtr';
const IS_SEASON_ACCESS_GRANTED = 'isSeasonAccessGranted';
const IS_NOT_SEASON_ACCESS_GRANTED = 'isNotSeasonAccessGranted';

const validators = {
    [IS_NW]: () => !!window.nw,
    [IS_NOT_NW]: () => !window.nw,
    [IS_PTR]: () => window.CONFIG.IS_PTR,
    [IS_NOT_PTR]: () => !window.CONFIG.IS_PTR,
    [IS_SEASON_ACCESS_GRANTED]: () => true,
    [IS_NOT_SEASON_ACCESS_GRANTED]: () => false
};

@Component({
    selector: 'app-enter-base',
    templateUrl: './base.component.pug',
    styleUrls: ['./base.component.less'],
    providers: [StoreService],
})
export class BaseComponent implements OnInit, OnDestroy {
    _destroySbj: Subject<void> = new Subject();

    SEASON_START_TIME: number = window.CONFIG.SEASON_START_TIME;

    @HostBinding('class.--ui') _ui = true;

    public isNw = !!window.nw;
    _ptrSbj: BehaviorSubject<boolean> = new BehaviorSubject(window.CONFIG.IS_PTR);
    ptr$: Observable<boolean> = this._ptrSbj.asObservable();

    public user: IUser;
    accessGranted: boolean = false;

    _showDetailsSbj: BehaviorSubject<boolean> = new BehaviorSubject(false);
    showDetails$: Observable<boolean> = this._showDetailsSbj.asObservable();

    _unlockingCpuSbj: BehaviorSubject<boolean> = new BehaviorSubject(null);
    unlockingCpu$: Observable<boolean> = this._unlockingCpuSbj.asObservable();

    _resoucesPriceSbj: BehaviorSubject<IResourcesPrice> = new BehaviorSubject(null);
    _resoucesPriceLoadingSbj: BehaviorSubject<string> = new BehaviorSubject(null);
    resoucesPriceLoading$: Observable<string> = this._resoucesPriceLoadingSbj.asObservable();

    _socketSrv: SocketService;

    _enterButtonLockedSbj: BehaviorSubject<boolean> = new BehaviorSubject(null);
    enterButtonLocked$ = this._enterButtonLockedSbj.asObservable();
    isFeatureSeason$ = this._featuresSrv.data$
        .pipe(map((data) => data['persistent-world'] || data['season-world']));

    versionData$ = this._versionSrv.data$;
    featuresData$ = this._featuresSrv.data$;

    @HostListener('document:keydown', ['$event'])
    onKeypress($event) {
        if ($event.code === 'KeyQ' && $event.altKey && $event.ctrlKey && $event.shiftKey) {
            this._ptrSbj.next(!this._ptrSbj.getValue());
        }
    }

    constructor(
        private _router: Router,
        private _route: ActivatedRoute,
        private _alert: AlertService,
        private _confirm: ConfirmService,

        private _authSrv: AuthService,
        private _apiSrv: ApiService,
        private _seasonsSrv: SeasonsService,
        private _loginSrv: LoginService,
        private _storeSrv: StoreService,
        private _versionSrv: VersionService,
        private _sessionSrv: SessionService,
        private _featuresSrv: FeaturesService,
        private _toastrSrv: ToastrService,
        private _socketLegacySrv: SocketServiceLegacy,
        private _localStorageSrv: LocalStorageService,

        private _dlgStoreCpuUnlockSrv: ShowDlgStoreCpuUnlockService,
        private _dlgStoreAccessKeySrv: ShowDlgStoreAccessKeyService,
        private _dlgCouponSrv: ShowDlgCouponService
    ) {
    }

    ngOnInit() {
        this.user = this._route.snapshot.data['user'];
        console.log(this.user);
        this.accessGranted = this._route.snapshot.data['accessGranted'];

        this._versionSrv.data$.pipe()

        this._initSocket();
    }

    async _initSocket() {
        const url = this._socketLegacySrv.options.websocketUrl;
        const token = this._localStorageSrv.get('auth', null, '');

        this._socketSrv = socketServiceFabric({ url, token });
        this._socketSrv.on(`user:${ this.user._id }/steam-purchase`)
            .pipe(takeUntil(this._destroySbj))
            .pipe(tap((...args) => {
            }))
            .subscribe();
    }

    ngOnDestroy() {
        this._destroySbj.next();
        this._destroySbj.complete();
    }

    async showDlgStoreCpuUnlock() {
        let action;
        try {
            action = await this._dlgStoreCpuUnlockSrv.show({
                steam: false,
                amount: this.user.resources.cpuUnlock,
                lifetimeSubscription: this.user.isLifetimeSubscriber(),
            });
        } catch (err) {
            console.error('inventory/base::pixelsDlg', err);
            return;
        }

        if (action.type === ACTIVATE_UNLOCK) {
            return;
        }
    }

    async onAccessDice(): Promise<boolean> {
        if (this.accessGranted) {
            return true;
        }

        const currentSeason = this._versionSrv.data.currentSeason;
        const seasonAccessCost = getSeasonAccessCost(this._versionSrv.data.seasonAccessCost);
        const unlimited = this.isUnlimitedAccessKeysSubscriber();

        if (!unlimited && seasonAccessCost > 0 && this.user.resources.accessKey < seasonAccessCost) {
            await this.showDlgStoreAccessKey();
            return false;
        }

        const accessCostMessage = unlimited || seasonAccessCost <= 0
            ? ''
            : `<br />This will consume ${ seasonAccessCost } Access Keys.`;

        try {
            await this._confirm.show({ data: {
                icon: 'app2/assets/order/attention-red.svg',
                iconWidth: 64,
                iconHeight: 64,
                title: 'Activate',
                innerHTML: `
                    <div class="--ui">Do you want to get access to Season ${ currentSeason }?${ accessCostMessage }</div>
                `,
                buttonOkLabel: 'Activate'
            }});
        } catch (err) {
            return false;
        }

        try {
            await this._seasonsSrv.getAccessGranted();
        } catch (err) {
            await this._alert.show({ data: {
                innerHTML: err
            }});

            return false;
        }

        this.accessGranted = true;
        this._toastrSrv.show(ToastSuccessComponent, { data: {
            message: `Access to Season ${ currentSeason } granted.`
        }});

        return true;
    }

    async showDlgStoreAccessKey() {
        const loading = this._resoucesPriceLoadingSbj.getValue();
        if (loading) {
            return;
        }

        const resourceType = 'accessKey';

        let resources = this._resoucesPriceSbj.getValue();
        if (!resources) {
            this._resoucesPriceLoadingSbj.next(resourceType);
            resources = await this._storeSrv.resources();
            this._resoucesPriceLoadingSbj.next(null);
            this._resoucesPriceSbj.next(resources);
        }

        let action;
        try {
            action = await this._dlgStoreAccessKeySrv.show({
                // steam: this.user.steam,
                steam: null,
                amount: this.user.resources.accessKey,
                unlimitedAccessKeys: this.isUnlimitedAccessKeysSubscriber(),
            });
        } catch (err) {
            console.error('inventory/base::pixelsDlg', err);
            return;
        }

        if (action.type === TRANSFER_KEYS) {
            this.user.resources[resourceType] -= action.payload;
        }
    }

    isUnlimitedAccessKeysSubscriber(): boolean {
        const checkSubscription = this.user && this.user.isUnlimittedAccessKeysSubscriber;

        if (typeof checkSubscription === 'function') {
            return checkSubscription.call(this.user);
        }

        return !!(this.user && (this.user as any).unlimitedAccessKeys);
    }

    showSteamPurchase() {
        window.location.href = 'https://store.screeps.com/world';
    }

    async showCouponDlg() {
        this._dlgCouponSrv.show();
    }

    showDetails() {
        this._showDetailsSbj.next(true);
    }

    hideDetails() {
        this._showDetailsSbj.next(false);
    }

    async unlockCPUfor7days() {
        if (!this._authSrv.Me) {
            this._loginSrv.show();
            return;
        }

        this._unlockingCpuSbj.next(true);

        try {
            await this._apiSrv.post('user/activate-ptr');

            this._authSrv.check();

            this._toastrSrv.show(ToastSuccessComponent, {
                data: {
                    message: 'Unlock CPU in PTR activated'
                }
            });
        } catch (err) {
        }

        this._unlockingCpuSbj.next(null);
    }


    goToSeason: boolean = false;
    async onEnter(): Promise<void> {
        const accessGranted = await this.onAccessDice();
        if (!accessGranted) {
            return;
        }

        this.enterSeason();
    }

    enterSeason(): void {
        const feature = this._versionSrv.data.serverData.features.find(({ name }) => name === 'persistent-world');

        const { item } = feature.menuData.find(({ item: { conditions } }) => {
            return !conditions || !conditions.some((condition) => {
                if (!validators[condition]) {
                    return false;
                }

                return !validators[condition]();
            });
        });

        if (item.href) {
            // @ts-ignore
            window.location = item.href;
        }

        if (item.versionData) {
            this._sessionSrv.initSessionServer({
                name: 'Seasonal server',

                apiUrl: item.config.API_URL,
                websocketUrl: item.config.WEBSOCKET_URL,
                prefix: '',

                settings: {
                    official: true,
                    host: 'screeps.com/season',
                    port: ''
                },

                users: null
            }, item.versionData);
        }

        if (item.redirectUrl) {
            this._router.navigate([item.redirectUrl]);
            this._enterButtonLockedSbj.next(true);
        }
    }
}
